module.exports = __webpack_public_path__ + "static/media/fvs_valve1_36.e0bbf85b.jpg";